// extracted by mini-css-extract-plugin
export default {"root":"IconJamIconsOutlineLogosPlus_root__00GKs","vector":"IconJamIconsOutlineLogosPlus_vector__R5vGl","icon":"IconJamIconsOutlineLogosPlus_icon__RMrSR"};